import React from "react";
import TimeBlock from "../atoms/TimeBlock";

export default function SegmentTime({ blocks = [] }) {
  return (
    <div className="segment-column-time">
      {blocks.map((b, i) => (
        <TimeBlock key={i} icon={b.icon} time={b.time} tz={b.tz} />
      ))}
    </div>
  );
}
